import { Action } from 'redux';
import { MarkerInfo, MarkerModifyInfo, MarkerCreateInfo } from '..';
import * as uuidv4 from 'uuid/v4';
import { MarkerToolState } from '../reducers/marker';

export const MARKER_ACTION_APPEND = 'MARKER_ACTION_APPEND';
export const MARKER_ACTION_DELETE = 'MARKER_ACTION_DELETE';
export const MARKER_ACTION_MODIFY = 'MARKER_ACTION_MODIFY';
export const MARKER_TOOL_ACTION_SET_STYLE = 'MARKER_TOOL_ACTION_SET_STYLE';

export interface MarkerAppendAction extends Action {
  type: typeof MARKER_ACTION_APPEND;
  info: MarkerInfo;
}

export interface MarkerDeleteAction extends Action {
  type: typeof MARKER_ACTION_DELETE;
  id: string;
}

export interface MarkerModifyAction extends Action {
  type: typeof MARKER_ACTION_MODIFY;
  info:  Partial<MarkerInfo>;
}

export interface MarkerToolSetStyleAction extends Action {
  type: typeof MARKER_TOOL_ACTION_SET_STYLE;
  colorIndex: MarkerToolState['colorIndex'];
}
export type MarkerAction = MarkerAppendAction | MarkerModifyAction | MarkerDeleteAction |
  MarkerToolSetStyleAction;

export function markerAppend(
  { reference, style, text = '', title = '' }: MarkerCreateInfo,
) : MarkerAppendAction {
  const date = new Date();
  return {
    type: MARKER_ACTION_APPEND,
    info: {
      reference, style, text, title,
      id: uuidv4(),
      createdAt: date.toISOString(),
      updatedAt: date.toISOString(),
    },
  };
}

export function markerDelete(id: string) : MarkerDeleteAction {
  return { id, type: MARKER_ACTION_DELETE };
}

export function markerModify(id: string, info: MarkerModifyInfo) : MarkerModifyAction {
  const date = new Date();
  return {
    info: { ...info, id, updatedAt: date.toISOString() },
    type: MARKER_ACTION_MODIFY,
  };
}

export function markerToolSetColorIndex(
  colorIndex: MarkerToolState['colorIndex'],
): MarkerToolSetStyleAction {
  return { colorIndex, type: MARKER_TOOL_ACTION_SET_STYLE };
}

export function isMarkerAction(action: Action): action is MarkerAction {
  switch (action.type) {
    case MARKER_ACTION_APPEND:
    case MARKER_ACTION_DELETE:
    case MARKER_ACTION_MODIFY:
    case MARKER_TOOL_ACTION_SET_STYLE:
      return true;
    default:
      return false;
  }
}
